import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b7869e46")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckboxFilter = _resolveComponent("CheckboxFilter")

  return (_openBlock(), _createBlock(_component_CheckboxFilter, {
    categories: _ctx.sortedCategories,
    selValues: _ctx.filterValues,
    collapsed: _ctx.collapsed,
    title: "Divisions",
    class: "filters filters--division",
    onUpdated: _ctx.updateFilter
  }, null, 8, ["categories", "selValues", "collapsed", "onUpdated"]))
})